export const waitForDuration = async (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

export const FLIP_ON_SELECTION_TIME_MS = 100;
export const FLIP_TO_DEFAULT_TIME_MS = 8000;
